import * as api from 'utils/axios';
import * as endpoints from 'services/auth/endpoints';

export const loginService = (params?: any) => api.sendPost(endpoints.LOGIN, params);
export const logoutService = (params?: any) => api.sendPost(endpoints.LOGOUT, params);
export const refreshtokenService = (params?: any) => api.sendPost(endpoints.REFRESHTOKEN, params);
